const Form = ({ children }) => (
  <section>
    <form className="form">{children}</form>
  </section>
);

export default Form;
